import axios from 'axios'
import store from '@/store/index.js'
import router from '@/router/index.js'

// Create a configured axios instance instead of modifying the global one
const apiAxios = axios.create()
apiAxios.defaults.withCredentials = true
apiAxios.defaults.withXSRFToken = true
apiAxios.defaults.xsrfCookieName = 'INTRANET-XSRF-TOKEN'
apiAxios.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response && error.response.status === 419) {
    const data = {
      status: true,
      msg: 'Sua sessão expirou, faça login novamente'
    }
    store.commit('setError', data)
    store.commit('setUser', undefined)
    localStorage.clear()
    router.push({ name: 'index' })
  }
  if (error.response && error.response.status === 401) {
    const data = {
      status: true,
      msg: 'Sua sessão expirou, faça login novamente'
    }
    store.commit('setError', data)
    store.commit('setUser', undefined)
    localStorage.clear()
    router.push({ name: 'index' })
  }
  if (error.response && error.response.status === 403) {
    const data = {
      status: true,
      msg: 'Você não tem permissão para executar esta ação'
    }
    store.commit('setError', data)
  }
  if (error.response && error.response.status === 404) {
    const data = {
      status: true,
      msg: 'Conteúdo não encontrado'
    }
    store.commit('setError', data)
  }
  return Promise.reject(error)
})

export default apiAxios
